import {NgModule} from "@angular/core";
import {FrameworkModule} from "../framework/framework.module";
import {SharedModule} from "../shared/shared.module";
import {AddressSharedModule} from "../address/address.shared.module";
import {ContactEditComponent} from "./contact-edit/contact-edit.component";
import {PosSharedModule} from "../pos/pos.shared.module";
import {ContactSingleSelectEditControlComponent} from "./controls/contact-single-select-edit-control.component";

@NgModule({
    imports: [
        SharedModule,
        FrameworkModule,
        PosSharedModule,
        AddressSharedModule
    ],
    declarations: [
        ContactEditComponent,
        ContactSingleSelectEditControlComponent
    ],
    exports: [
        ContactEditComponent,
        ContactSingleSelectEditControlComponent
    ]
})
export class ContactSharedModule {
}
